/*
  elewa-cursor.js
  ---------------
  What it does: the custom cursor on computers (approved by Tobi, 10 Oct, mockups/cursor-mockup-v2.html).
  - Resting: Tobi's submark, small and still (her own file: never recoloured, resized or animated).
  - Over a link or button (incl. Sonatations pieces): a chartreuse ring around the submark.
  - Over a product: the same ring, gently pulsing. (The product photo gets a coloured border via CSS in elewa-shop.css.)
  - No words, no arrows.
  Only on devices with a mouse or trackpad. Phones and tablets keep their normal behaviour.
  Over text fields the normal text cursor comes back. For people who turn motion off, the ring doesn't pulse.
  If this file fails, the normal cursor stays (the page only hides it once this script has started).
  Where it's used: layout/theme.liquid (every page); markup is the #ElewaCursor element there.
*/
(function () {
  'use strict';
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var cur = document.getElementById('ElewaCursor');
  if (!cur) return;
  var root = document.documentElement;
  root.classList.add('elewa-cursor-on');

  var PRODUCT = '.elewa-card, .elewa-home__patches a, .elewa-others a, .elewa-gallery';
  var TEXT = 'input:not([type=submit]):not([type=button]):not([type=radio]):not([type=checkbox]), textarea, select, [contenteditable="true"]';
  var LINK = 'a, button, summary, label, [role=button], input[type=submit], input[type=button], input[type=radio], input[type=checkbox]';
  var x = -100, y = -100, raf = null;

  function place() { cur.style.transform = 'translate(' + x + 'px, ' + y + 'px)'; raf = null; }

  document.addEventListener('mousemove', function (e) {
    x = e.clientX; y = e.clientY;
    cur.classList.add('is-visible');
    if (!raf) raf = requestAnimationFrame(place);
  }, { passive: true });

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    // Fields inside another component's shadow DOM (Shopify Forms on the contact page) show the normal cursor.
    if (t.closest(TEXT) || t.closest('shopify-forms-embed, iframe')) { cur.className = 'elewa-cursor is-hidden'; return; }
    if (t.closest(PRODUCT)) { cur.className = 'elewa-cursor is-visible is-product'; return; }
    if (t.closest(LINK)) { cur.className = 'elewa-cursor is-visible is-link'; return; }
    cur.className = 'elewa-cursor is-visible';
  });

  document.addEventListener('mouseleave', function () { cur.classList.remove('is-visible'); });
  window.addEventListener('blur', function () { cur.classList.remove('is-visible'); });
})();
